webpackJsonp([1],{

/***/ "+gyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_urls__ = __webpack_require__("imha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ews_soap__ = __webpack_require__("MRq5");







var validateEmail = function validateEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

/* harmony default export */ __webpack_exports__["a"] = ({
    getSTContacts: function getSTContacts() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var result;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            result = void 0;
                            // eslint-disable-next-line

                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_urls__["a" /* default */].contacts).then(function (response) {
                                result = response;
                            }).catch(function (error) {
                                result = [];
                            });

                        case 3:
                            return _context.abrupt('return', result);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    getOutlookContacts: function getOutlookContacts(callback) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var mailbox;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            mailbox = window.Office.context.mailbox;

                            mailbox.makeEwsRequestAsync(__WEBPACK_IMPORTED_MODULE_5__ews_soap__["a" /* default */].getOutlookContacts(), function (response) {
                                callback(response);
                            });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    createContacts: function createContacts(contacts, callback) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var mailbox, callEWS;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            mailbox = window.Office.context.mailbox;

                            callEWS = function callEWS(newContacts, callbackFunction) {
                                if (contacts.length === 0) {
                                    callbackFunction();
                                    return;
                                }
                                mailbox.makeEwsRequestAsync(__WEBPACK_IMPORTED_MODULE_5__ews_soap__["a" /* default */].createNewContactXML(newContacts.pop()), function (response) {
                                    if (response.status !== 'succeeded') {
                                        // eslint-disable-line
                                    }
                                    return callEWS(newContacts, callbackFunction);
                                });
                            };

                            return _context3.abrupt('return', callEWS(contacts, callback));

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    filterContacts: function filterContacts(STContacts, outlookEmails) {
        var newContacts = [];
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(STContacts, function (stContact) {
            if (stContact.person.contact.email !== '' && validateEmail(stContact.person.contact.email)) {
                var shouldBeAdded = true;
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(outlookEmails, function (outlookEmail) {
                    if (stContact.person.contact.email === outlookEmail) {
                        shouldBeAdded = false;
                    }
                });
                if (shouldBeAdded) {
                    newContacts.push(stContact);
                }
            }
        });
        return newContacts;
    },
    getEmailsFromEWSXML: function getEmailsFromEWSXML(xml) {
        var parser = new DOMParser();
        var responseDoc = parser.parseFromString(xml, 'text/xml');
        return responseDoc.getElementsByTagName('t:EmailAddresses');
    }
});

/***/ }),

/***/ "0/1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Preloader__ = __webpack_require__("juKD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['newContactsLength'],
    components: {
        preloader: __WEBPACK_IMPORTED_MODULE_0__Preloader__["a" /* default */]
    },
    data: function data() {
        return {
            inProgress: false
        };
    },

    methods: {
        close: function close() {
            this.$emit('close', false);
        },
        ok: function ok() {
            this.inProgres = true;
            this.$emit('ok');
        }
    }
});

/***/ }),

/***/ "15ZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_DealsService__ = __webpack_require__("LWPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_AuthService__ = __webpack_require__("SGRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ContactsService__ = __webpack_require__("+gyp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SyncContactsModal__ = __webpack_require__("AVKc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_EmailService__ = __webpack_require__("dfd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Preloader__ = __webpack_require__("juKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorModal__ = __webpack_require__("eKWi");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a,
        'sync-modal': __WEBPACK_IMPORTED_MODULE_7__SyncContactsModal__["a" /* default */],
        'error-modal': __WEBPACK_IMPORTED_MODULE_10__ErrorModal__["a" /* default */],
        preloader: __WEBPACK_IMPORTED_MODULE_9__Preloader__["a" /* default */]
    },
    watch: {
        forwarded: function forwarded() {
            var _this = this;

            setTimeout(function () {
                _this.forwarded = false;
            }, 5000);
        }
    },
    data: function data() {
        return {
            deals: [],
            selectedDeals: [],
            dealsDropDown: [],
            newContacts: [],
            forwarded: false,
            forwarding: false,
            syncModal: false,
            officePackage: null,
            preloader: false,
            errorModal: false
        };
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this2.preloader = true;
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_4__services_DealsService__["a" /* default */].getDeals();

                        case 3:
                            _this2.deals = _context.sent;

                            _this2.preloader = false;

                            _this2.dealsDropDown = [{
                                type: 'Deals',
                                emails: _this2.deals
                            }];

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },


    methods: {
        openSyncModal: function openSyncModal() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.preloader = true;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_6__services_ContactsService__["a" /* default */].getSTContacts();

                            case 3:
                                _ref = _context2.sent;
                                data = _ref.data;

                                __WEBPACK_IMPORTED_MODULE_6__services_ContactsService__["a" /* default */].getOutlookContacts(function (OutlookContacts) {
                                    var outlookEmails = [];
                                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(__WEBPACK_IMPORTED_MODULE_6__services_ContactsService__["a" /* default */].getEmailsFromEWSXML(OutlookContacts.value), function (emailAddress) {
                                        var emailEntries = emailAddress.childNodes;
                                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(emailEntries, function (emailEntry) {
                                            outlookEmails.push(emailEntry.textContent);
                                        });
                                    });
                                    _this3.newContacts = __WEBPACK_IMPORTED_MODULE_6__services_ContactsService__["a" /* default */].filterContacts(data, outlookEmails);
                                    _this3.syncModal = true;
                                    _this3.preloader = false;
                                });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        sync: function sync() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__services_ContactsService__["a" /* default */].createContacts(_this4.newContacts, function (isSent) {
                                    _this4.syncModal = isSent;
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        forward: function forward() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var forwardTo;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.forwarding = true;
                                forwardTo = [];

                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_this5.selectedDeals, function (deal) {
                                    forwardTo.push(deal.email);
                                });
                                __WEBPACK_IMPORTED_MODULE_8__services_EmailService__["a" /* default */].sendMail(forwardTo, function () {
                                    _this5.errorModal = true;
                                });
                                _this5.forwarding = false;
                                _this5.forwarded = true;
                                _this5.selectedDeals = [];

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_5__services_AuthService__["a" /* default */].logout();
            this.$router.push('/');
        }
    },
    computed: {
        selectedEmailsCount: function selectedEmailsCount() {
            if (this.selectedDeals.length > 0) {
                return this.selectedDeals.length;
            }
            return '';
        },
        plural: function plural() {
            return this.selectedDeals.length > 1 ? 's' : '';
        },
        forwardDisabled: function forwardDisabled() {
            return this.selectedDeals.length === 0;
        }
    }
});

/***/ }),

/***/ "5inX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Aj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__ = __webpack_require__("15ZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2a0d9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__ = __webpack_require__("zS/B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2a0d9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AVKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncContactsModal_vue__ = __webpack_require__("0/1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc09b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncContactsModal_vue__ = __webpack_require__("Ha0Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyncContactsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc09b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyncContactsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ha0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modale opened",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(!_vm.inProgres)?_c('h4',[_vm._v(_vm._s(_vm.newContactsLength)+" new contact(s) will be added.")]):_vm._e(),_vm._v(" "),(_vm.inProgres)?_c('h4',[_vm._v("Creating "+_vm._s(_vm.newContactsLength)+" new contact(s), please wait ...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.inProgress)?_c('div',[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.ok()}}},[_vm._v("OK")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){_vm.close()}}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(_vm.inProgress)?_c('div',{staticClass:"sync-loader"},[_c('preloader')],1):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('img',{attrs:{"src":__webpack_require__("eEzd"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iw9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-position login-form-wrap"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('div',[_c('div',{staticClass:"input-grid"},[_c('label',{attrs:{"for":"email"}},[_vm._v("SalesTrekker E-Mail:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],attrs:{"type":"email","id":"email","required":"","placeholder":"example@e-mail.com"},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-grid"},[_c('label',{attrs:{"for":"password"}},[_vm._v("SalesTrekker Password:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],attrs:{"type":"password","id":"password","required":"","minlength":"6","placeholder":"******"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"relative-div"},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.loginDisabled}},[_vm._v("Sign in")]),_vm._v(" "),(_vm.preloader)?_c('preloader'):_vm._e()],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.loginModal)?_c('login-modal',{on:{"close":function($event){_vm.loginModal = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('a',{attrs:{"href":"https://salestrekker.com","target":"_blank"}},[_vm._v("Get 30-day free trial of SalesTrekker")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_urls__ = __webpack_require__("imha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthService__ = __webpack_require__("SGRL");



/* eslint-disable*/






var DEALS_FETCH_TIME = 'dealsFetchTime';

var shouldFetchDeals = function shouldFetchDeals() {
    var MINUTES = 15;
    if (localStorage.getItem(DEALS_FETCH_TIME)) {
        var lastFetchedDealsTime = parseInt(localStorage.getItem(DEALS_FETCH_TIME), 10) ? parseInt(localStorage.getItem(DEALS_FETCH_TIME), 10) : 0;
        var currentTime = +new Date();
        var exp = currentTime - lastFetchedDealsTime > 60 * 1000 * MINUTES;
        if (exp > 0) {
            return true;
        }
        return false;
    }
    return true;
};
/* harmony default export */ __webpack_exports__["a"] = ({
    getDeals: function getDeals() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var dealsData, _dealsData, deals, senderEmail;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dealsData = [];

                            if (!shouldFetchDeals()) {
                                _context.next = 7;
                                break;
                            }

                            _dealsData = void 0;
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config_urls__["a" /* default */].deals, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_6__AuthService__["a" /* default */].getToken() } }).then(function (response) {
                                _dealsData = response.data;
                            }).catch(function (error) {
                                console.log(error);
                            });

                        case 5:
                            localStorage.setItem(DEALS_FETCH_TIME, +new Date());
                            localStorage.setItem('deals', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_dealsData));

                        case 7:
                            dealsData = JSON.parse(localStorage.getItem('deals'));
                            deals = [];
                            senderEmail = window.Office.context.mailbox.item.sender.emailAddress;

                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(dealsData, function (deal) {
                                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(deal.contacts, { email: senderEmail }) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(deal.clients, { email: senderEmail })) {
                                    deals.push(deal);
                                }
                            });
                            return _context.abrupt('return', deals);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5930af97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("WMPL");
function injectStyle (ssrContext) {
  __webpack_require__("TSf7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5930af97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SOAP_HEADER = '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" \nxmlns:m="http://schemas.microsoft.com/exchange/services/2006/messages" xmlns:xsd="http://www.w3.org/2001/XMLSchema" \nxmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">\n<soap:Header><RequestServerVersion Version="Exchange2013" xmlns="http://schemas.microsoft.com/exchange/services/2006/types" \nsoap:mustUnderstand="0" /></soap:Header>';
var SOAP_FOOTER = '</soap:Envelope>';
/* harmony default export */ __webpack_exports__["a"] = ({
  getForwardXML: function getForwardXML(id, changeKey, email) {
    return SOAP_HEADER + '<soap:Body><m:CreateItem MessageDisposition="SendAndSaveCopy"><m:Items><t:ForwardItem>\n    <t:ToRecipients><t:Mailbox><t:EmailAddress>' + email + '</t:EmailAddress></t:Mailbox></t:ToRecipients>\n    <t:ReferenceItemId Id="' + id + '" ChangeKey="' + changeKey + '"></t:ReferenceItemId><t:NewBodyContent BodyType="HTML">\n    </t:NewBodyContent></t:ForwardItem></m:Items></m:CreateItem></soap:Body>' + SOAP_FOOTER;
  },
  getItemDataXML: function getItemDataXML(id) {
    return SOAP_HEADER + '<soap:Body><GetItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages" \n    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"><ItemShape><t:BaseShape>IdOnly</t:BaseShape></ItemShape>\n    <ItemIds><t:ItemId Id="' + id + '"/></ItemIds></GetItem></soap:Body>' + SOAP_FOOTER;
  },
  createNewContactXML: function createNewContactXML(contact) {
    return SOAP_HEADER + '<soap:Body><m:CreateItem MessageDisposition="SaveOnly"><m:Items><t:Contact>\n    <t:FileAsMapping>LastCommaFirst</t:FileAsMapping><t:GivenName>' + contact.person.information.firstName + '</t:GivenName>\n    <t:MiddleName>' + contact.person.information.middleName + '</t:MiddleName>\n    <t:CompanyName>' + contact.company.information.name + '</t:CompanyName>\n    <t:EmailAddresses><t:Entry Key="EmailAddress1">' + contact.person.contact.email + '</t:Entry>\n    <t:Entry Key="EmailAddress2">' + contact.person.contact.email + '</t:Entry>\n    </t:EmailAddresses><t:Surname>' + contact.person.information.familyName + '</t:Surname>\n    <t:PhoneNumbers>\n    <t:Entry Key="HomePhone"> +' + contact.person.contact.primaryCode + '-' + contact.person.contact.primary + '</t:Entry>\n    </t:PhoneNumbers>\n    </t:Contact>\n   </m:Items></m:CreateItem>\n    </soap:Body>' + SOAP_FOOTER;
  },
  getOutlookContacts: function getOutlookContacts() {
    return SOAP_HEADER + '<soap:Body><m:FindItem Traversal="Shallow"><m:ItemShape><t:BaseShape>AllProperties</t:BaseShape>\n    <t:AdditionalProperties><t:FieldURI FieldURI="contacts:DisplayName" /></t:AdditionalProperties></m:ItemShape>\n    <m:IndexedPageItemView MaxEntriesReturned="999" Offset="0" BasePoint="Beginning" /><m:ParentFolderIds>\n    <t:DistinguishedFolderId Id="contacts" /></m:ParentFolderIds></m:FindItem></soap:Body>' + SOAP_FOOTER;
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_style_app_scss__ = __webpack_require__("5inX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_style_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_style_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_AuthService__ = __webpack_require__("SGRL");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*eslint-disable*/








var Promise = __webpack_require__("hKoQ");
Promise.polyfill();
// eslint-disable-next-line
Office.initialize = function (reason) {
    // eslint-disable-next-line
    if (!isAppLoaded) {
        // eslint-disable-next-line
        isAppLoaded = true;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
        // eslint-disable-next-line
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = __WEBPACK_IMPORTED_MODULE_6__services_AuthService__["a" /* default */].getToken();

        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
            if (to.matched.some(function (record) {
                return record.meta.requiresAuth;
            })) {
                if (!__WEBPACK_IMPORTED_MODULE_6__services_AuthService__["a" /* default */].getToken() && !__WEBPACK_IMPORTED_MODULE_6__services_AuthService__["a" /* default */].expirationCheck()) {
                    next({
                        path: '/',
                        query: { redirect: to.fullPath }
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        });
        // eslint-disable-next-line
        new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
            el: '#app',
            router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
            template: '<App/>',
            components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
        });
    }
};
/* eslint-disable no-new */

/***/ }),

/***/ "SGRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_urls__ = __webpack_require__("imha");




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(credentials) {
    var headers = {
      'cache-control': 'no-cache',
      'content-type': 'application/json;charset=UTF-8'
    };
    var authURL = __WEBPACK_IMPORTED_MODULE_2__config_urls__["a" /* default */].login;
    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(authURL, credentials, { headers: headers });
  },
  logout: function logout() {
    localStorage.removeItem('tokenDetails');
    localStorage.removeItem('dealsFetchTime');
    localStorage.removeItem('deals');
  },
  saveToken: function saveToken(token) {
    var tokenDetails = {
      expirationTime: +new Date() + 86400000,
      token: 'Bearer ' + token
    };
    localStorage.setItem('tokenDetails', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tokenDetails));
  },
  getToken: function getToken() {
    if (localStorage.getItem('tokenDetails')) {
      return JSON.parse(localStorage.getItem('tokenDetails')).token;
    }
    return false;
  },
  expirationCheck: function expirationCheck() {
    var currentTime = +new Date();

    if (localStorage.getItem('tokenDetails') && JSON.parse(localStorage.getItem('tokenDetails')).expirationTime) {
      var tokenExp = parseInt(JSON.parse(localStorage.getItem('tokenDetails')).expirationTime, 10);
      return currentTime - tokenExp > 60;
    }
    return false;
  }
});

/***/ }),

/***/ "TSf7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VeAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__ = __webpack_require__("eBed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dec193_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__ = __webpack_require__("WZf/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dec193_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WMPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WZf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modale opened",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.close()}}},[_vm._v("Close")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('img',{attrs:{"src":__webpack_require__("eEzd"),"alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("eEzd"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Sign in to SalesTrekker has failed.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Email__ = __webpack_require__("6Aj3");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
    }, {
        path: '/email',
        name: 'Email',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Email__["a" /* default */],
        meta: { requiresAuth: true }
    }]
}));

/***/ }),

/***/ "dfd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ews_soap__ = __webpack_require__("MRq5");



/* harmony default export */ __webpack_exports__["a"] = ({
    sendMail: function sendMail(recipients, callback) {
        var mailbox = window.Office.context.mailbox;
        var item = mailbox.item;
        mailbox.makeEwsRequestAsync(__WEBPACK_IMPORTED_MODULE_1__ews_soap__["a" /* default */].getItemDataXML(item.itemId), function (getItemResponse) {
            var parser = new DOMParser();
            var responseDoc = parser.parseFromString(getItemResponse.value, 'text/xml');
            var responseItem = responseDoc.getElementsByTagName('t:ItemId')[0];
            var changeKey = responseItem.getAttribute('ChangeKey');
            var id = responseItem.getAttribute('Id');
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(recipients, function (to) {
                mailbox.makeEwsRequestAsync(__WEBPACK_IMPORTED_MODULE_1__ews_soap__["a" /* default */].getForwardXML(id, changeKey, to), function (forwardResponse) {
                    if (forwardResponse.status !== 'succeeded') {
                        callback(false);
                    }
                });
            });
        });
    }
});

/***/ }),

/***/ "eBed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        close: function close() {
            this.$emit('close', false);
        }
    }
});

/***/ }),

/***/ "eEzd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/salestrekker.2c9c87c.png";

/***/ }),

/***/ "eKWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__ = __webpack_require__("m87b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3093c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__ = __webpack_require__("gaBi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3093c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gaBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modale opened",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.close()}}},[_vm._v("Close")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('img',{attrs:{"src":__webpack_require__("eEzd"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Error while trying to forward E-Mail.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "imha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BASE_URL = "https://app.salestrekker.com/api/v1/";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: BASE_URL + "account/authenticate/",
  contacts: BASE_URL + "contacts/available/",
  deals: BASE_URL + "tickets/shared"
});

/***/ }),

/***/ "juKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378204f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__ = __webpack_require__("tmi9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378204f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m87b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        close: function close() {
            this.$emit('close', false);
        }
    }
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginModal__ = __webpack_require__("VeAd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Preloader__ = __webpack_require__("juKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_AuthService__ = __webpack_require__("SGRL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'login-modal': __WEBPACK_IMPORTED_MODULE_2__LoginModal__["a" /* default */],
        preloader: __WEBPACK_IMPORTED_MODULE_3__Preloader__["a" /* default */]
    },
    beforeCreate: function beforeCreate() {
        if (!__WEBPACK_IMPORTED_MODULE_4__services_AuthService__["a" /* default */].expirationCheck()) {
            this.$router.push('/email');
        }
    },
    data: function data() {
        return {
            loginDisabled: false,
            credentials: {
                email: '',
                password: ''
            },
            loginModal: false,
            preloader: false
        };
    },

    methods: {
        login: function login() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loginDisabled = true;
                                _this.preloader = true;
                                _context.prev = 2;
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_4__services_AuthService__["a" /* default */].login(_this.credentials);

                            case 5:
                                response = _context.sent;

                                __WEBPACK_IMPORTED_MODULE_4__services_AuthService__["a" /* default */].saveToken(response.data.authToken);
                                _this.preloader = false;
                                _this.$router.push('/email');
                                _context.next = 16;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](2);

                                _this.loginModal = true;
                                _this.preloader = false;
                                _this.loginDisabled = false;

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 11]]);
            }))();
        }
    }
});

/***/ }),

/***/ "tmi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[_c('ul',[_c('li',{staticClass:"one"}),_vm._v(" "),_c('li',{staticClass:"two"}),_vm._v(" "),_c('li',{staticClass:"three"}),_vm._v(" "),_c('li',{staticClass:"four"}),_vm._v(" "),_c('li',{staticClass:"five"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f565fa2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("Iw9z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f565fa2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zS/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forward-email"},[_c('div',{staticClass:"navbar-wrapper"},[_c('a',{staticClass:"btn btn-sync",attrs:{"disabled":_vm.preloader},on:{"click":function($event){_vm.openSyncModal()}}},[_vm._v("Sync contacts")]),_vm._v(" "),_c('button',{staticClass:"btn forward-btn",attrs:{"disabled":_vm.forwardDisabled || _vm.forwarding || _vm.preloader || _vm.selectedDeals.length < 1},on:{"click":function($event){_vm.forward()}}},[_vm._v("\n            Forward "+_vm._s(_vm.selectedEmailsCount)+" E-Mail"+_vm._s(_vm.plural)+"\n        ")])]),_vm._v(" "),(!_vm.forwarded )?_c('div',{staticClass:"clear"},[_c('div',{staticClass:"sync-wrapper"},[(_vm.preloader)?_c('div',[_c('preloader',{staticClass:"preloader-position"}),_vm._v(" "),_vm._m(0)],1):_vm._e()]),_vm._v(" "),(!_vm.preloader)?_c('div',{attrs:{"id":"emails"}},[(_vm.deals.length > 0 && !_vm.preloader)?_c('div',[_c('label',{staticClass:"typo__label"},[_vm._v("Deals")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.dealsDropDown,"multiple":true,"close-on-select":false,"clear-on-select":false,"hide-selected":true,"preserve-search":true,"group-values":"emails","group-label":"type","track-by":"id","label":"name","disabled":_vm.preloader,"placeholder":"Select deals"},model:{value:(_vm.selectedDeals),callback:function ($$v) {_vm.selectedDeals=$$v},expression:"selectedDeals"}})],1):_vm._e(),_vm._v(" "),(_vm.deals.length === 0)?_c('div',{staticClass:"text-center"},[_vm._v("You have no available deals.")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.preloader)?_c('button',{staticClass:"btn logout-btn ",attrs:{"disabled":_vm.preloader},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.forwarded)?_c('div',[_c('h3',[_vm._v("Forwarded E-Mail(s)")]),_vm._v(" "),_c('p',[_vm._v("Your E-Mail(s) have been forwarded to the selected deal(s).")])]):_vm._e(),_vm._v(" "),(_vm.syncModal)?_c('sync-modal',{attrs:{"newContactsLength":_vm.newContacts.length},on:{"close":function($event){_vm.syncModal = $event},"ok":function($event){_vm.sync()}}}):_vm._e(),_vm._v(" "),(_vm.errorModal)?_c('error-modal',{on:{"close":function($event){_vm.errorModal = $event},"ok":function($event){_vm.errorModal = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-text"},[_c('p',[_vm._v("This can take few minutes. Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.31bb0f831d569cbdf16c.js